import { Action } from '@ngrx/store';
import { AuthenticationResult, SessionInfo, SessionState } from '../../data/authentication-info';
import { SessionActions } from './session-actions';
/**
 * Created by ashok on 10/05/17.
 */


let InitSession: SessionInfo = {
    loginForm: false,
    needRefresh: false,
}
export function sessionReducer(state: SessionInfo = InitSession, action: any): SessionInfo {
    switch (action.type) {
        case SessionActions.SHOW_LOGIN:
            return Object.assign({}, state, {
                loginForm: true
            });
        case SessionActions.LOGIN:
            return {
                status: SessionState.LoggingIn,
                userName: action.payload.userName,
                password: action.payload.password,
                loginForm: false
            };
        case SessionActions.SET_PLAYER_ID:
            return Object.assign({}, state, { playerId: action.payload });
        case SessionActions.LOGOUT:
            return Object.assign({}, state, {
                status: SessionState.LoggedOut,
                authToken: '',
                password: '',
                loginForm: true,
                playerId: null
            });
        case SessionActions.LOGIN_SUCCESS:
            let newInfo: SessionInfo = action.payload;
            return Object.assign({}, state, newInfo,
                { loginForm: false, status: SessionState.LoggedIn });
        case SessionActions.LOGIN_FAILED:
            let result: AuthenticationResult = action.payload;
            return {
                status: SessionState.LoginFailed,
                userName: state.userName,
                exception: result.exception,
                loginForm: true
            };
        case SessionActions.CLEAR_LOGIN_ERROR:
            return Object.assign({}, state, {
                status: SessionState.LoggedOut,
                exception: '',
                loginForm: true
            });
        case SessionActions.SET_NEED_REFRESH:
            state['needRefresh'] = action.payLoad;
            console.debug("setting reducer [0]", state, action.payload)
            const obj = Object.assign({}, state, {
                needRefresh: action.payload
            })
            console.debug("setting reducer [1]", obj )
            return obj
            // return {
            //     ...state,
            //     needRefresh: action.payLoad,
            // }
        case SessionActions.CLEAR_ALL_STATES:
            return InitSession; // This resets the state to its initial value
        default:
            return state;
    }
}